export enum ImportLoadsStatus {
  ON_GOING = 'ON_GOING',
  FETCHING_LOADS_FROM_TMS = 'FETCHING_LOADS_FROM_TMS',
  UPDATING_LOCAL_LOADS = 'UPDATING_LOCAL_LOADS',
  REMOVING_NOT_FETCHED_FUTURE_LOADS = 'REMOVING_NOT_FETCHED_FUTURE_LOADS',
  SUCCEED = 'SUCCEED',
  PARTIALLY_SUCCEED = 'PARTIALLY_SUCCEED',
  FAILED = 'FAILED',
}
